// Shared types for Variables pages

export type VariableValueType = 'string' | 'number' | 'percentage' | 'range' | 'type' | 'boolean';

export const VALUE_TYPE_OPTIONS: { value: VariableValueType; label: string }[] = [
  { value: 'string', label: 'String' },
  { value: 'number', label: 'Number' },
  { value: 'percentage', label: 'Percentage' },
  { value: 'range', label: 'Range' },
  { value: 'type', label: 'Type' },
  { value: 'boolean', label: 'Boolean' },
];
